export function parseNumber(value: string): number {
  value = value.toString().replace(/,/g, '');
  return parseFloat(value);
}
